import { IconSprites } from '@constants/enums/sprites'

import { Column } from '@components/ui-core/column/column'
import { Icon } from '@components/ui-core/icon/icon'
import { Row } from '@components/ui-core/row/row'
import { Text } from '@components/ui-core/text/text'

import { type IntroConfig, type PlansPageData, type Product, Products } from '../types'

import styles from './intro.module.scss'

export const Intro = ({ data }: { readonly data: PlansPageData['introSection'] }) => (
  <Column crossAxisAlignment="center" gap="8x" className={styles.introSection}>
    <Text as="h1" variant="headerXlarge" className={styles.title}>
      {data.title}
    </Text>
    <Row mainAxisAlignment="center" crossAxisAlignment="center" className={styles.intro}>
      {Products.map(productToIntroItem(data.items))}
    </Row>
  </Column>
)

const productToIntroItem =
  (introConfig: IntroConfig) =>
  (product: Product): React.JSX.Element => {
    const { name, copy } = introConfig[product]

    return (
      <Column key={product} className={styles.item} gap="2x">
        <Row mainAxisAlignment="start" crossAxisAlignment="center" gap="2x">
          <Icon variant={IconSprites[name]} className={styles.icon} aria-hidden="true" />
          <Text as="span" variant="bodyLarge" className={styles.name}>
            {name}
          </Text>
        </Row>
        <Row>
          <Text as="span" variant="bodySmall" className={styles.copy}>
            {copy}
          </Text>
        </Row>
      </Column>
    )
  }
